import { isEmpty } from '../../helpers/metal';

export default {
  hideImg(state) {
    const display = state.displayOptions.find((d) => d.id === state.visualSchedule.visual_schedule_display_id);
    if (display) return display.name === 'Title only';
    return false;
  },

  hideTitle(state) {
    const display = state.displayOptions.find((d) => d.id === state.visualSchedule.visual_schedule_display_id);
    if (display) return display.name === 'Image only';
    return false;
  },

  isPrimaryTherapist(_state, getters) {
    return getters.isVisualScheduleOwner;
  },

  isVisualScheduleOwner(state) {
    return state.userId === state.visualSchedule.user_id;
  },

  scheduleCards(state) {
    if (!state.visualSchedule.visual_schedule_cards_attributes) return [];
    // eslint-disable-next-line no-underscore-dangle
    return state.visualSchedule.visual_schedule_cards_attributes.filter((c) => c._destroy !== 1);
  },

  revealImageForCardPosition: (state) => (position) =>
    state.visualSchedule.visual_schedule_reveal_images_attributes.find((image) => {
      // eslint-disable-next-line no-underscore-dangle
      if (image._destroy !== 1) return Number(image.position) === Number(position);
      return null;
    }),

  visualScheduleStreamer: (state, getters) => getters.visitorById(state.visualScheduleSharing.streamerId),

  isVisualScheduleSharing: (state) =>
    !isEmpty(state.visualSchedule) && state.visualScheduleSharing.id === state.visualSchedule.id,

  isVisualScheduleStreamer: (state) => state.visualScheduleSharing.streamerId === state.visitor.id,
};
